export default __webpack_public_path__ + "static/media/logo_eyebee_fondo_negrov2.eb6a89d8.jpg";